import React from "react";
import { Outlet, useLocation } from "react-router";
import ProfileCard from "../../profile/ProfileCard";

const MobileProfileLayout = () => {
  const location = useLocation();
  const currentUrl = location.pathname;
  return currentUrl === "/profile" ? <ProfileCard /> : <Outlet />;
};

export default MobileProfileLayout;
